<template>
    <v-container class="toggle animated" fluid>
        <v-row v-if="compliancesData.length == 0" class="fill-height">
            <v-col class="d-flex justify-center mt-16">
                <v-card align="center" class="mt-16" elevation="0">
                    <v-icon size="200">
                        mdi-calendar-alert
                    </v-icon>
                    <v-card-text class="text-button">
                        No Schedule Created for Compliance
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row dense v-else>
            <v-col cols="12">
                <v-btn
                    @click="printReport()"
                    color="routesColor"
                    class="mb-2"
                    prepend-icon="mdi-printer"
                >
                    Print Report
                </v-btn>
            </v-col>
            <v-col v-for="compliance in compliancesData" :key="compliance" cols="12" xl="4" md="6">
                <v-card @click="showComplianceReport(compliance)" class="pa-2 d-flex flex-column fill-height" elevation="3">
                    <v-card-text>
                        <div class="text-h6 font-weight-black">{{ compliance.compliance_name }}</div>
                        <div class="text-body-2 font-weight-bold mt-4">Schedules</div>
                        <v-row class="mt-2" dense v-for="schedule in compliance.schedules" :key="schedule">
                            <v-col v-if="compliance.is_term_separated" cols="12">
                                <b>{{ schedule.term.name }}</b>
                            </v-col>
                            <v-col cols="12" md="6">
                                Deadline: <b>{{ formatDate(schedule.deadline) }}</b>
                            </v-col>
                            <v-col v-if="schedule.is_extended" cols="12" md="6">
                                Deadline Extension: <b>{{ formatDate(schedule.deadline_extension) }}</b>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

    <DeansReportsDialog ref="DeansReportsDialog"/>
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue'
import DeansReportsDialog from '../Dialogs/DeansReportsDialog.vue';
import { generateComplianceReportPerOfficePDF } from '@/composables/pdf/compliance-report-per-office';

export default defineComponent({
    components: {
        DeansReportsDialog
    },
    data () {
        return {
            loading: false,
            compliancesData: []
        }
    },
    methods: {
        init(){
            this.loading = true
            const token = localStorage.getItem('aums-token')
            axios.get(process.env.VUE_APP_SERVER_URL + '/compliances/findAllComplianceWithSchedule/' + this.$store.state.semester_schoolyear.id,
            { headers:
                { 
                    'Authorization': `Bearer ${token}`,
                }
            }
            ).then((res)=>{
                if(res.data){
                    this.loading = false
                    this.compliancesData = res.data
                }
            }).catch((error)=>{
                if(error.response.status == 401){
                    this.loading = false

                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                }
                else{
                    console.log(error)
                }
            });
        },
        showComplianceReport(data){
            this.$refs.DeansReportsDialog.initView(data)
        },
        formatDate(value) {
            if (!value) return '—';

            const date = new Date(value);
            if (Number.isNaN(date.getTime())) return value;

            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            });
        },
        async printReport(){
            const token = localStorage.getItem('aums-token')
            const semester = this.$store.state.semester_schoolyear;
            const office = this.$store.state.user?.office;

            try {
                const res = await axios.get(
                    process.env.VUE_APP_SERVER_URL + '/reports/getComplianceReportByOffice/' + semester.id + '/' + office.id,
                    { headers: { Authorization: `Bearer ${token}` } }
                );

                if (res && res.data) {
                    await generateComplianceReportPerOfficePDF(
                        res.data,
                        office?.name || 'Office Report',
                        `${semester?.semester || ''} S.Y. ${semester?.schoolyear || ''}`.trim(),
                        this.$store.state.user || 'Dean'
                    );
                }
            } catch (error) {
                if (error.response?.status == 401) {
                    localStorage.removeItem("vuex");
                    localStorage.removeItem("aums-token");
                    window.location.reload();
                } else {
                    console.log(error)
                }
            }
        }
    },
    mounted(){
        this.init()
    },
})
</script>

<style scoped>

</style>